import React from 'react'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const PaginationSkeleton = () => {
  return (
    <div className='pagination_skeleton container-fluid'>
      <pre>
        <table border="1" className='bg-white'>
          <thead>
            <tr>
              <th className='p-1 text-center'>Image</th>
              <th className='p-1 text-center' style={{ minWidth: '200px' }}>Title</th>
              <th className='p-1 text-center'>Price</th>
              <th className='p-1 text-center'>Edit/Delete</th>
              <th className='p-1 text-center'>stock</th>
            </tr>
          </thead>
          <tbody>
            {[...Array(4)].map((p,i) => {
              return (
                <tr key={i}>
                  <td><p className='m-2' style={{ width: '80px', height: '80px', backgroundColor: '#CACACA', borderRadius: "10px", justifySelf: 'center' }}>&nbsp;</p></td>
                  <td><p style={{ width: '180px', backgroundColor: '#CACACA', borderRadius: "20px", justifySelf: 'center' }}>&nbsp;</p></td>
                  <td className='text-center'><p style={{ width: '20px', backgroundColor: '#CACACA', borderRadius: "5px", justifySelf: 'center' }}>&nbsp;</p></td>
                  <td className='text-center'>
                    <EditIcon style={{ color: '#CACACA' }} />
                    <DeleteIcon style={{ color: '#CACACA' }} />
                  </td>
                  <td className='text-center'><p style={{ width: '20px', backgroundColor: '#CACACA', borderRadius: "5px", justifySelf: 'center' }}>&nbsp;</p></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </pre>
    </div>
  )
}

export default PaginationSkeleton
